/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ICustomer,
  ISearchCustomerReq,
  ISearchCustomerRes,
} from '../interfaces/customer';
import * as baseAdapter from './baseAdapter';

export const queryCustomers = async () => {
  const ret = await baseAdapter.get<ICustomer[]>('/customer');
  return ret;
};

export const getCustomer = async (id: number) => {
  const ret = await baseAdapter.get<ICustomer>('/customer/get/' + id);
  return ret;
};

export const searchCustomers = async (req: ISearchCustomerReq) => {
  const ret = await baseAdapter.post<ISearchCustomerRes>('/customer/gets', req);
  return ret;
};

export const addCustomer = async (data: Partial<ICustomer>) => {
  const ret = await baseAdapter.post('/customer/create', data);
  return ret;
};

export const editCustomer = async (data: Partial<ICustomer>) => {
  const ret = await baseAdapter.put(`/customer/update/${data.id}`, data);
  return ret;
};

export const deleteCustomer = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/customer/deletecustomer/${id}`);
  return ret;
};

export const recoverCustomer = async (id: number) => {
  const ret = await baseAdapter.post(`/customer/recover/${id}`, {});
  return ret;
};

export const importCustomer = async (data: ICustomer[]) => {
  const ret = await baseAdapter.post<any>(`/customer/import`, data);
  return ret;
};
